import React, { useState } from 'react';
import { Menu, MenuItem, IconButton } from '@mui/material';
import MoreVertIcon from '../icons/more-vertical.svg';
import MoreHorizontalIcon from '../icons/more-horizontal.svg';

const OptionsMenu = ({ options, direction = 'vertical', disabled = false, loading = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled || loading}
        style={{ padding: '4px', width: '32px', height: '32px' }}
      >
        {loading ? (
          <div className="w-4 h-4 border-2 border-gray-300 border-t-primary rounded-full animate-spin"></div>
        ) : (
          <img
            src={direction === 'vertical' ? MoreVertIcon : MoreHorizontalIcon}
            alt="Options"
            style={{
              width: '20px',
              height: '20px',
              objectFit: 'contain',
            }}
          />
        )}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          className: "flex flex-col justify-center",
          style: {
            background: "#FFFFFF 0% 0% no-repeat padding-box",
            boxShadow: "0px 12px 26px #0000001C",
            border: "1px solid #F7F7F7",
            opacity: 1,
            borderRadius: '12px',
          },
        }}
      >
        {options.map((option, index) => (
          <div key={option.label} className="flex flex-col gap-2">
            <MenuItem
              onClick={() => {
                handleClose();
                option.action();
              }}
              className={`flex items-center space-x-2 px-4 py-2`}
              style={{ fontFamily: "Montserrat", color: option.color || "#000" }}
            >
              {option.icon && (
                <img
                  src={option.icon}
                  alt={`${option.label} icon`}
                  className="w-5 h-5 mr-2"
                />
              )}
              <span
                className="font-semibold text-[16px]"
                style={{ color: option.color || "#000" }}
              >
                {option.label}
              </span>
            </MenuItem>
            {index < options.length - 1 && (
              <div className="w-[130px] h-0 border-t border-[#F7F7F7] opacity-100 mx-auto"></div>
            )}
          </div>
        ))}
      </Menu>
    </div>
  );
};

export default OptionsMenu;
